import { render, staticRenderFns } from "./SectionSustainabilityV1.vue?vue&type=template&id=a0b8825e&"
import script from "./SectionSustainabilityV1.vue?vue&type=script&lang=js&"
export * from "./SectionSustainabilityV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionSustainabilityV1.vue?vue&type=style&index=0&id=a0b8825e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismCertifications: require('/app/components/organisms/common/OrganismCertifications.vue').default})
